/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Configure_Associated_ValvesInputs */



/**
* | output |
* | --- |
* | "Configure associated th. heads" |
*
* @param {Configure_Associated_ValvesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const configure_associated_valves = /** @type {((inputs?: Configure_Associated_ValvesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Configure_Associated_ValvesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Configure associated th. heads")
	return /** @type {LocalizedString} */ ("Configurer les têtes th. associées")
});